import { useState } from 'react'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AuthDialog } from '../../../auth/AuthDialog'

export const AuthLinks = () => {
    const { t } = useTranslation("header")
    const [authModalOpen, setAuthModalOpen] = useState(false)
    const [authMode, setAuthMode] = useState('login')

    const openAuthModal = (mode) => {
        setAuthMode(mode)
        setAuthModalOpen(true)
    }

    return (<>
        <Button
            type="button"
            onClick={() => openAuthModal('signup')}
            sx={{
                color: "secondary.main",
                display: "block",
                fontSize: "14px",
                fontWeight: "bold",
                textAlign: "center",
                px: 2,
                py: 1,
                border: "1px solid rgba(0, 56, 70, 0.12)",
                backgroundColor: "rgba(255, 255, 255, 0.72)",
                "&:hover": {
                    backgroundColor: "primary.light",
                    borderColor: "primary.main",
                }
            }}
        >
            {t("signup")}
        </Button>
        <Button
            type="button"
            onClick={() => openAuthModal('login')}
            variant="contained"
            sx={{
                color: "white",
                display: "block",
                fontSize: "14px",
                fontWeight: "bold",
                textAlign: "center",
                px: 2.5,
                py: 1,
                backgroundColor: "secondary.dark",
                "&:hover": {
                    backgroundColor: "primary.main",
                }
            }}
        >
            {t("login")}
        </Button>

        <AuthDialog
            open={authModalOpen}
            mode={authMode}
            onClose={() => setAuthModalOpen(false)}
            onModeChange={setAuthMode}
        />

    </>
    )
}
